import { render, staticRenderFns } from "./QuestionType.vue?vue&type=template&id=20d47188&scoped=true&"
import script from "./QuestionType.vue?vue&type=script&lang=js&"
export * from "./QuestionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d47188",
  null
  
)

export default component.exports